import type { DataNode } from 'antd/es/tree'

export const transformToTreeData = (nodes): DataNode[] => {
    return nodes.map((node) => {
        const item: DataNode = { title: node.children ? node.name : `${node.name} ${node.code}`, value: node.code }
        if (node.children) {
            item.children = transformToTreeData(node.children)
            item.selectable = false
        }
        return item
    })
}
